import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyEquipmentBlockValidationSchema } from "../schemas/equipmentActions.schema";

interface UseCompanyEquipmentBlockProps {
  equipmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useCompanyEquipmentBlock = ({ equipmentId, onSuccess, onError }: UseCompanyEquipmentBlockProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, CompanyEquipmentBlockValidationSchema>({
    mutationKey: ['companyEquipmentBlock', equipmentId],
    mutationFn: (data) => privateAxios.put(`/client/equipments/${equipmentId}/block`, {
      equipment: {
        block_reason: data.block_reason,
        scheduled_to_unblock_at: data.scheduled_to_unblock_at_str || undefined,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useCompanyEquipmentBlock;
